/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import DateUtils from '@zvuk-b2b/react-uikit/toolkit/DateUtils';
import IconEye from '@zvuk-b2b/react-uikit/ui/icons/Eye';

import VideoMediafilePosterContent from './PosterContent';
import styles from './index.module.scss';
import { VideoMediafilePreview } from './VideoMediafilePreview';
import { TEXTS } from './texts';

interface Props {
  link?: string | null;
  title?: string | null;
  uploading?: boolean;
  duration?: number | null;
  extension?: string | null;
  url?: string;
  isVideo?: boolean;

  withPreview?: boolean;
  containerClassName?: string;
  posterClassName?: string;
}

const VideoMediafilePoster: React.FC<Props> = ({
  link,
  title,
  uploading,
  duration,
  extension,
  url,
  isVideo,

  withPreview = false,
  containerClassName,
  posterClassName,
}) => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  const onClose = () => setIsPreviewOpen(false);
  const onOpen = () => withPreview && setIsPreviewOpen(true);

  return (
    <div
      onClick={!isPreviewOpen ? onOpen : undefined}
      className={`${styles.container}${containerClassName ? ` ${containerClassName}` : ''} ${withPreview && styles.withPreview}`}>
      <VideoMediafilePosterContent
        link={link}
        title={title}
        uploading={uploading}
        className={posterClassName}
      />
      {duration && (
        <div className={styles.duration}>{DateUtils.msToHMS(duration, ['hours', 'minutes', 'seconds'])}</div>
      )}
      {extension && <div className={styles.extension}>{extension}</div>}
      <div
        onClick={() => {
          setIsPreviewOpen(true);
        }}
        className={styles.preview}>
        <IconEye />

        <span>{TEXTS.PREVIEW}</span>
      </div>
      {isPreviewOpen && url && (
        <VideoMediafilePreview
          isVideo={!!isVideo}
          url={url}
          onClose={onClose}
        />
      )}
    </div>
  );
};
export default VideoMediafilePoster;
